

    if (window.Sentry) {
      window.Sentry.init({ dsn: "https://2062d0a4929b45348643784b5cb39c36@sentry.wixpress.com/1643", environment: 'Editor' });
    }
  

    import React from 'react';
    import ReactDOM from 'react-dom';
    import { withStyles } from '@wix/native-components-infra';
    import EditorAppWrapper from '@wix/yoshi-flow-editor/runtime/esm/EditorAppWrapper.js';
    import Widget from '/home/builduser/work/a037be9d14b7f75e/packages/communities-blog-ooi/src/components/Post/Widget/index.tsx';
    import createController from '/home/builduser/work/a037be9d14b7f75e/packages/communities-blog-ooi/src/components/Post/controller.ts';

    
import { createHttpClient } from '@wix/yoshi-flow-editor/runtime/esm/controller/httpClientProp';
    

    
var initI18n = null;

    
const multilingualDisabled = false;

    
import { createExperiments, createWidgetExperiments } from '@wix/yoshi-flow-editor/runtime/esm/experiments';
    

    
import { createRavenClient } from '@wix/yoshi-flow-editor/error-monitor';
    import Raven from '@wix/yoshi-flow-editor/raven-js';
    var createErrorMonitor = function(options) {
      return createRavenClient({
        Raven,
        ...options,
      });
    };
    

    
var I18nextProvider = React.Fragment;


      import { PureExperimentsProvider } from '@wix/yoshi-flow-editor';
      var ExperimentsProvider = React.Fragment;
      

import { BILoggerProvider } from '@wix/yoshi-flow-editor/runtime/esm/react/BILogger/BILoggerProvider';

import { FedopsLoggerProvider } from '@wix/yoshi-flow-editor/runtime/esm/react/FedopsLoggerProvider';

import { HttpProvider } from '@wix/yoshi-flow-editor';

import { TPAComponentsProvider } from 'wix-ui-tpa';

import { BaseUiEnvironmentProviderWrapper } from '@wix/yoshi-flow-editor/runtime/esm/react/BaseUiEnvironmentProviderWrapper';

var providers = {
  I18nextProvider,
  ExperimentsProvider,
  PureExperimentsProvider,
  BILoggerProvider,
  FedopsLoggerProvider,
  HttpProvider,
  TPAComponentsProvider,
  BaseUiEnvironmentProviderWrapper,
}

    import * as fedopsLogger from '@wix/yoshi-flow-editor/fedops';

    
  var importedApp = {};

    var componentName = 'Post';
    var projectName = 'communities-blog-ooi';
    var sentryConfig = {
      DSN: 'https://2062d0a4929b45348643784b5cb39c36@sentry.wixpress.com/1643',
      id: '2062d0a4929b45348643784b5cb39c36',
      projectName: 'communities-blog-ooi',
      teamName: 'blogas',
      errorMonitor: true,
    };
    var stylesParams = null;
    var experimentsConfig = {"centralized":true,"scopes":["wix-social-blog","ricos"]};
    var fedopsConfig = null;
    var translationsConfig = {"enabled":false,"icuEnabled":false};
    var defaultTranslations = null;
    var styleHocConfig = {"enabled":true};
    var biConfig = null;
    var appDefinitionId = "14bcded7-0066-7c35-14d7-466cb3f09103";
    var componentId = "211b5287-14e2-4690-bb71-525908938c81";
    var localeDistPath = 'assets/locales';
    var persistentAcrossPages = false;
    var shouldUseEssentials = true;
    var shouldSkipMultipleRendersAfterViewModeChange = true;
    var withErrorBoundary = true;

    import { createVisitorBILogger as biLogger } from '/home/builduser/work/a037be9d14b7f75e/packages/communities-blog-ooi/target/generated/bi/createBILogger.ts';
    
      import { hot } from '@wix/component-hot-loader';
      var UserComponent = hot(module, Widget);
    

    var EditorComponent = React.createElement(EditorAppWrapper, {
      UserComponent,
      appDefinitionId,
      componentId,
      name: componentName,
      sentryConfig: sentryConfig,
      styleHocConfig: styleHocConfig,
      experimentsConfig: experimentsConfig,
      fedopsConfig: fedopsConfig,
      multilingualDisabled,
      translationsConfig: translationsConfig,
      defaultTranslations: defaultTranslations,
      shouldUseEssentials,
      persistentAcrossPages,
      projectName: projectName,
      biConfig: biConfig,
      biLogger: biLogger,
      stylesParams,
      withErrorBoundary,
      shouldSkipMultipleRendersAfterViewModeChange,
      userController: createController,
      customInitAppForPage: importedApp.initAppForPage,
      optionalDeps: {
        initI18n,
        fedopsLogger,
        withStylesHoc: withStyles,
        createHttpClient,
        createExperiments,
        createWidgetExperiments,
        createErrorMonitor,
        providers,
      },
      localeDistPath: localeDistPath,
    });
    ReactDOM.render(EditorComponent, document.getElementById('root'));
